export default "__VITE_ASSET__BuzSvFZk__"